import { Updater } from '@headless-tree/core';
import { useCallback, useState } from 'react';

import { InternalTreeItem, TreeItemID, TreeItemTypes } from './types';

export const useMultiSelect = (
  items: Record<TreeItemID, InternalTreeItem>,
  types: TreeItemTypes[],
) => {
  const [selectedItems, setSelectedItems] = useState<TreeItemID[]>([]);

  const handleSetSelectedItems = useCallback(
    (newIds: Updater<TreeItemID[]>) => {
      const updatedIds = Array.isArray(newIds) ? newIds : newIds(selectedItems);

      // Filter to only include items of allowed types
      const filteredIds = updatedIds.filter((id) => {
        const item = items[id];
        return item && types.includes(item.type);
      });

      setSelectedItems(filteredIds);
    },
    [selectedItems, types, items],
  );

  const clearSelection = useCallback(
    () => setSelectedItems((prev) => (prev.length === 0 ? prev : [])),
    [],
  );

  return {
    selectedItems,
    setSelectedItems,
    handleSetSelectedItems,
    clearSelection,
  };
};
